import logo from '../../assets/logo.png';
import { useIsMobile } from '../../hooks/useIsMobile';

// Teintes de la pastille, une par module (le reste du gabarit est identique)
const COLORS = {
    emerald: 'bg-emerald-100 text-emerald-800',
    blue: 'bg-blue-100 text-blue-800',
    amber: 'bg-amber-100 text-amber-800',
    purple: 'bg-purple-100 text-purple-800',
    pink: 'bg-pink-100 text-pink-800',
    teal: 'bg-teal-100 text-teal-800'
};

/**
 * ModuleBar - Bande de marque en haut de chaque écran de module (standard mobile)
 * Logo Cabaza à gauche, pastille du module courant à droite.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.icon - Icône lucide du module
 * @param {string} props.label - Nom du module
 * @param {string} props.color - Clé de COLORS (défaut: emerald)
 * @param {string} props.className - Classes additionnelles
 *
 * Réservée au téléphone (< 640 px) : sur tablette et bureau le site affiche son propre
 * en-tête, la bande n'est donc pas rendue du tout (et non simplement masquée en CSS).
 */
const ModuleBar = ({ icon: Icon, label, color = 'emerald', className = '' }) => {
    const isMobile = useIsMobile();
    if (!isMobile) return null;

    return (
    <div className={`flex items-center justify-between h-12 pt-3 ${className}`}>
        <img src={logo} alt="Cabaza" className="h-7 w-auto" />
        <span className={`inline-flex items-center gap-1.5 h-7 pl-2 pr-2.5 rounded-full text-[13px] font-semibold ${COLORS[color] || COLORS.emerald}`}>
            {Icon && <Icon className="w-4 h-4 shrink-0" strokeWidth={1.75} />}
            {label}
        </span>
    </div>
    );
};

export default ModuleBar;
